import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Client",
    dataIndex: "userDetails",
    render: defaultRender,
    fixed:"left"
  },
  {
    title: "File Name",
    dataIndex: "file",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Submit",
    dataIndex: "submit",
    render: defaultRender,
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Notes",
    dataIndex: "fileNotes",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => <StatusBadge status={value} />,
  },
  {
    title: "Action",
    dataIndex: "action",
    fixed: "right",
  },
];

export default columns;
